import { useMutation } from '@tanstack/react-query';
import { useCallback, useRef } from 'react';
import { authService } from '../../services/authService';

const DEBOUNCE_DELAY = 500;

export const useSubmitEmailOtpCode = options => {
  const timerRef = useRef(null);
  const mutationRef = useRef(null);

  const mutation = useMutation({
    mutationFn: payload =>
      authService.submitEmailOtp(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return { success: true, data };
        }
        if (status === 403) {
          options?.onCaptchaExpired?.();
          return { captchaExpired: true };
        }
        if (status === 401) {
          options?.onTokenExpired && options.onTokenExpired();
        }
        return { error: data?.errors?.[0] };
      }),
  });

  mutationRef.current = mutation;

  const debouncedMutateAsync = useCallback(
    payload =>
      new Promise((resolve, reject) => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
          mutationRef.current.mutateAsync(payload).then(resolve).catch(reject);
        }, DEBOUNCE_DELAY);
      }),
    [],
  );

  return { ...mutation, mutateAsync: debouncedMutateAsync };
};
